import React, { FunctionComponent } from 'react'
import style from './cartboxPriceViewSwitcher.css'
import Select from 'react-select'
import { PriceViewFlag } from '../../entities/PriceViewFlag'
import useTranslation from '../../hooks/useTranslation'

export type Props = {
    availablePriceViews: PriceViewFlag[]
    currentPriceView: PriceViewFlag
    switchPriceView: Function
}

const CartboxPriceViewSwitcher: FunctionComponent<Props> = (props) => {
    const {availablePriceViews, currentPriceView, switchPriceView} = props
    const {t} = useTranslation()

    const options = availablePriceViews.map((value) => ({
        value,
        label: t(`cart.priceView.${value}`),
    }))

    const placeholder = t(`cart.priceView.placeholder`)

    return (
        <div className={style.pricesSwitcherContainer} data-testid="cart-price-view-switcher">
            <Select
                isMulti={false}
                options={options}
                onChange={(selectedOptions) => switchPriceView(selectedOptions.value)}
                value={options.filter(option => currentPriceView === option.value)}
                placeholder={placeholder}
            />
        </div>
    )

}

export default CartboxPriceViewSwitcher
